export const parseCandidatePageId = (pageId) => {
  return pageId.match(/(.*)--(.*)/);
};

/*
const updateVotePrefsFromPositionData = (positionData) => {
  const { position, candidate } = parseCandidatePageId(pageId);
  if (positionData.yes === candidate) {
    // this candidate is the "yes" vote for the position
    responseData.data.vote = "Y";
  }
  else if (positionData[candidate]) {
    // we know this isn't "yes", but it could be no or undecided
    responseData.data.vote = positionData[candidate];
  }
  else if (positionData.yes) {
    // we know someone else is the "yes", and we haven't made a decision
    // on this candidate, so we set this to no
    responseData.data.vote = "N";
  }
};
*/



// WEBPACK FOOTER //
// ./src/state/ballots/position.js